// Ícono Lucide por nombre de sección (compartido entre la ficha y el formulario).
import {
  BarChart3, Briefcase, Clock, IdCard, Layers, type LucideIcon, MapPin,
  Phone, Share2, SlidersHorizontal, Sparkles, Tag,
} from "lucide-react";
import { deaccent } from "./textMatch.ts";

export function sectionIcon(section: string): LucideIcon {
  const s = deaccent(section);
  if (s.includes("dato")) return IdCard;
  if (s.includes("red")) return Share2;
  if (s.includes("detalle")) return SlidersHorizontal;
  if (s.includes("direccion")) return MapPin;
  if (s.includes("clasific")) return Tag;
  if (s.includes("perfil")) return Briefcase;
  if (s.includes("financ")) return BarChart3;
  if (s.includes("contacto")) return Phone;
  if (s.includes("sistema")) return Clock;
  if (s.includes("adicional") || s.includes("informacion")) return Sparkles;
  if (s.includes("precio")) return BarChart3;
  if (s.includes("servicio")) return Layers;
  return Layers;
}
